module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "centered": "",
      "dark": "",
      "color": "brown lighten-1"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _c('v-tab', {
    key: "editor",
    attrs: {
      "to": _vm.baseRoute + 'editor',
      "router": ""
    }
  }, [_vm._v("\n            Editor\n         ")]), _vm._v(" "), _c('v-tab', {
    key: "simulator",
    attrs: {
      "to": _vm.baseRoute + 'simulator',
      "disabled": !_vm.parseInfo || !_vm.parseInfo.isOk,
      "router": ""
    }
  }, [_vm._v("\n            Simulator\n         ")])], 1), _vm._v(" "), _c('div', [_c('router-view', {
    attrs: {
      "moduleId": _vm.moduleId
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d685141a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shdl/ShdlModule.vue
// module id = 1216
// module chunks = 1